import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, computed, watch } from "vue";
import InfoText from "@/account/components/shared/info-text.vue";
import LoginWelcome from "@/account/components/login/login-welcome.vue";
import PhoneInput from "@/account/components/inputs/phone-input.vue";
import PasswordInput from "@/account/components/inputs/password-input.vue";
import PinInput from "@/account/components/inputs/pin-input.vue";
import NewPasswordInput from "@/account/components/inputs/new-password-input.vue";
import TransitionSlide from "@sazka/design-system/src/transitions/transition-slide.vue";
import { TransitionSlideDirection } from "@sazka/design-system/src/transitions/transition-slide-direction";
import LoginFooter from "./login-footer.vue";
import useUserAccount from "@/account/use-user-account";
import useAuthentication from "../../composables/use-authentication";
import useAuthenticationData, {
    authenticationErrors,
    authenticationData,
} from "../../composables/use-authentication-data";
import useAuthenticationFlows, { authenticationStep } from "@/account/composables/use-authentication-flows";


export default /*@__PURE__*/_defineComponent({
  __name: 'login-content',
  setup(__props) {

const { loginUser } = useUserAccount();
const { sendPinProcess, nextAuthenticationStep, prevAuthenticationStep } = useAuthentication();
const { clearAuthenticationErrors } = useAuthenticationData();
const { openLoginPassModal } = useAuthenticationFlows();

const loginWelcome = ref(null);
const phoneInput = ref(null);
const passwordInput = ref(null);
const pinInput = ref(null);
const newPasswordInput = ref(null);
const newPasswordErrorMessage = ref<string>();
const transitionDirection = ref<TransitionSlideDirection>("rtl");

const nextStepInternal = () => {
    clearAuthenticationErrors();

    if (
        (authenticationStep.value == "LoginPhone" && !phoneInput.value.checkIfIsValid()) ||
        (authenticationStep.value == "ForgPinLog" && !pinInput.value.checkIfIsValid()) ||
        (authenticationStep.value == "ForgNewPass" && !newPasswordInput.value.checkIfIsValid())
    ) {
        return;
    }

    nextAuthenticationStep();
};

const prevStepInternal = () => {
    prevAuthenticationStep();
};
const goToLoginPassInternal = () => {
    openLoginPassModal();
};

const inputKeyUpEventHandler = async (event: KeyboardEvent) => {
    if (event.key === "Enter") {
        event.preventDefault();
        if (authenticationStep.value == "LoginWelcome" || authenticationStep.value == "LoginPass") {
            await loginUser();
        } else {
            nextStepInternal();
        }
    }
};

const resendPin = async () => {
    authenticationErrors.pinErrorMessage = "";
    await sendPinProcess(true);
    pinInput.value.pinResended(!authenticationErrors.pinErrorMessage);
};

const loginInternal = async () => {
    if (
        (authenticationStep.value == "LoginWelcome" && !loginWelcome.value.checkIfIsValid()) ||
        (authenticationStep.value == "LoginPass" && !passwordInput.value.checkIfIsValid())
    ) {
        return;
    }

    await loginUser();
    console.log();
};

const modalTitle = computed(() => {
    switch (authenticationStep.value) {
        case "LoginWelcome":
            return "Vítejte v Sazka Klubu!";
        case "LoginPhone":
            return "Přihlášení";
        case "LoginPass":
            return "Zadejte heslo";
        case "ForgPinGen":
        case "ForgPinLog":
            return "Zapomenuté heslo";
        case "ForgPinOk":
            return "Ověření bylo úspěšné. V&nbsp;dalším kroku si nastavte nové heslo.";
        case "ForgNewPass":
            return "Vytvořit nové heslo";
        case "ForgNewPassOk":
            return "Hotovo";
        default:
            return "";
    }
});

const modalPerex = computed(() => {
    switch (authenticationStep.value) {
        case "LoginWelcome":
            return "Nyní se můžete přihlásit a využívat výhody Sazka Klubu naplno.";
        case "LoginPhone":
        case "LoginPass":
            return "do vašeho účtu Sazka Klubu";
        case "ForgPinGen":
            return "Pro nastavení nového hesla vám na telefon zašleme 4místný PIN kód.";
        case "ForgNewPassOk":
            return "Heslo bylo úspěšně změněno, nyní se můžete přihlásit.";
        case "RegNewPass":
        case "RegVerPhone":
        case "RegPinLog":
            return "Už jsme skoro tam!";
        default:
            return "";
    }
});

const classForCurrentState = computed(() => {
    switch (authenticationStep.value) {
        case "LoginWelcome":
            return "login-content--welcome";
        case "ForgPinGen":
        case "ForgPinLog":
        case "ForgPinOk":
        case "ForgNewPass":
        case "ForgNewPassOk":
            return "login-content--forg-pass";
        default:
            return "";
    }
});

watch(authenticationStep, (newAccountState, oldAccountState) => {
    if (
        (oldAccountState == "LoginPass" && newAccountState == "LoginPhone") ||
        (oldAccountState == "LoginPass" && newAccountState == "LoginWelcome") ||
        (oldAccountState == "ForgPinGen" && newAccountState == "LoginPass") ||
        (oldAccountState == "ForgPinLog" && newAccountState == "LoginPass")
    ) {
        transitionDirection.value = "ltr";
    } else {
        transitionDirection.value = "rtl";
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TransitionSlide, { direction: transitionDirection.value }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["login-content", classForCurrentState.value]),
        key: _unref(authenticationStep)
      }, [
        _createVNode(InfoText, {
          title: modalTitle.value,
          perex: modalPerex.value,
          showBackLink: _unref(authenticationStep) == 'LoginPass',
          onPrevStep: prevStepInternal,
          class: "login-content__header"
        }, null, 8, ["title", "perex", "showBackLink"]),
        _withDirectives(_createVNode(LoginWelcome, {
          ref_key: "loginWelcome",
          ref: loginWelcome,
          class: "login-content__welcome"
        }, null, 512), [
          [_vShow, _unref(authenticationStep) == 'LoginWelcome']
        ]),
        _withDirectives(_createVNode(PhoneInput, {
          ref_key: "phoneInput",
          ref: phoneInput,
          class: "login-content__phone",
          name: "phone",
          onInputKeyUp: inputKeyUpEventHandler,
          modelValue: _unref(authenticationData).userName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(authenticationData).userName) = $event)),
          "error-message": _unref(authenticationErrors).phoneErrorMessage,
          "onUpdate:errorMessage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(authenticationErrors).phoneErrorMessage) = $event))
        }, null, 8, ["modelValue", "error-message"]), [
          [_vShow, _unref(authenticationStep) == 'LoginPhone']
        ]),
        _withDirectives(_createVNode(PasswordInput, {
          ref_key: "passwordInput",
          ref: passwordInput,
          class: "login-content__password",
          onInputKeyUp: inputKeyUpEventHandler,
          modelValue: _unref(authenticationData).password,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(authenticationData).password) = $event)),
          name: "password",
          "error-message": _unref(authenticationErrors).passwordErrorMessage,
          "onUpdate:errorMessage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(authenticationErrors).passwordErrorMessage) = $event)),
          focus: true
        }, null, 8, ["modelValue", "error-message"]), [
          [_vShow, _unref(authenticationStep) == 'LoginPass']
        ]),
        _withDirectives(_createVNode(PinInput, {
          ref_key: "pinInput",
          ref: pinInput,
          class: "login-content__pin",
          modelValue: _unref(authenticationData).pin,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(authenticationData).pin) = $event)),
          name: "sms_code",
          "phone-number": _unref(authenticationData).userName,
          "error-message": _unref(authenticationErrors).pinErrorMessage,
          "onUpdate:errorMessage": _cache[5] || (_cache[5] = ($event: any) => ((_unref(authenticationErrors).pinErrorMessage) = $event)),
          onResendPin: resendPin
        }, null, 8, ["modelValue", "phone-number", "error-message"]), [
          [_vShow, _unref(authenticationStep) == 'ForgPinLog']
        ]),
        _withDirectives(_createVNode(NewPasswordInput, {
          ref_key: "newPasswordInput",
          ref: newPasswordInput,
          class: "login-content__new-password",
          modelValue: _unref(authenticationData).password,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(authenticationData).password) = $event)),
          name: "new-password",
          passwordErrorMessage: newPasswordErrorMessage.value,
          "error-message": _unref(authenticationErrors).newPasswordErrorMessage,
          "onUpdate:errorMessage": _cache[7] || (_cache[7] = ($event: any) => ((_unref(authenticationErrors).newPasswordErrorMessage) = $event))
        }, null, 8, ["modelValue", "passwordErrorMessage", "error-message"]), [
          [_vShow, _unref(authenticationStep) == 'ForgNewPass']
        ]),
        _createVNode(LoginFooter, {
          class: "login-content__footer",
          "authentication-step": _unref(authenticationStep),
          onNextStep: nextStepInternal,
          onGoToLoginPass: goToLoginPassInternal,
          onLogin: loginInternal
        }, null, 8, ["authentication-step"])
      ], 2))
    ]),
    _: 1
  }, 8, ["direction"]))
}
}

})